import { Box, Paper, Typography } from '@mui/material'
import React from 'react'
import SubjectStatics from './SubjectStatics'
import Grid2 from '@mui/material/Unstable_Grid2'

function Statics({teacherStatics}) {
  const {teacherSubjectStatics = []} = teacherStatics
  return (
      <Grid2 container spacing={2} sx={{ padding: 2 }}>
        {
          teacherSubjectStatics.map((data, index) => (<SubjectStatics key={index} staticsData={data}  />))
          
        }
        
      </Grid2>
  );
}

export default Statics